import React, {useContext} from 'react';
import {CitizenContext} from "../context/citizen-context.jsx";
import Dropzone from "../../../../../../components/dropzone/dropzone.jsx";

const CitizenAttaches = () => {
    const {setAttaches, attachesDescription, setAttachesDescription, files} = useContext(CitizenContext);

    return (
        <Dropzone
            title={"Anexos"}
            attaches={files}
            setAttaches={setAttaches}
            attachesDescription={attachesDescription}
            setAttachesDescription={setAttachesDescription}
        />
    );
};

export default CitizenAttaches;